module.exports = __webpack_public_path__ + "pf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pf.svg
// module id = 1007
// module chunks = 0